'use strict';

/* eslint max-lines: 0 */
/* eslint max-lines-per-function: 0 */
/* eslint quote-props: 0 */

var Page        = require('stb-component-page'),
    page        = new Page({$node: document.getElementById('pageMain')}),

    dom         = require('spa-dom'),
    keys        = require('stb-keys'),

    Footer          = require('mag-component-footer'),
    PanelSet        = require('mag-component-panel-set'),
    Panel           = require('mag-component-panel'),
    LayoutList      = require('mag-component-layout-list'),
    Provider        = require('mag-data-cacher'),
    app             = require('mag-app'),
    ModalMessage    = require('mag-component-modal'),
    RadioList       = require('mag-component-radio-list'),
    Scrollbar       = require('stb-component-scrollbar'),

    exit            = require('../utils/app.exit'),
    sortQuality     = require('../utils/sort.quality'),
    selectFile      = require('../utils/select.file'),
    prepareMovies   = require('../utils/prepare.movies'),
    parseTime       = require('../utils/parse.time'),
    infoPanel       = require('../components/info.panel'),

    footer = new Footer({visible: false, parent: page}),

    leftList = new LayoutList({
        cycle: true,
        data: [],
        fixedData: true,
        size: app.metrics.leftList,
        events: {
            blur: function () {
                LayoutList.prototype.blur.call(this);
                footer.hide();
            },
            focus: function () {
                footer.show();
            }
        }
    }),

    panelSet, resetFilters, actionModalReset, filmList,

    leftPanel = new Panel({
        title: [
            {
                value: gettext('Menu'),
                className: 'name'
            }
        ],
        events: {
            focus: function () {
                Panel.prototype.defaultEvents.focus.call(this);
                if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
                    footer.hide();
                } else {
                    footer.init({
                        left: {
                            code: keys.menu,
                            action: function () {
                                if ( panelSet.panels[panelSet.focusIndex] === leftPanel ) {
                                    panelSet.blur();
                                    footer.hide();
                                    actionModalReset.show();
                                    actionModalReset.focus();
                                }
                            }
                        },
                        middle: [
                            {
                                code: keys.f1,
                                title: gettext('Reset filters'),
                                action: resetFilters
                            }
                        ]
                    });
                }
            }
        },
        children: [leftList]
    }),

    $headerAmount = dom.tag('div', {className: 'amount'}, '0'),
    filmPanel = new Panel({
        title: [
            {
                value: gettext('Films'),
                className: 'name'
            },
            dom.tag(
                'div',
                {className: 'amountContainer'},
                $headerAmount
            )
        ],
        main: true
    }),

    rightPanel = new Panel({
        title: [
            {
                value: gettext('Info'),
                className: 'name'
            }
        ],
        events: {
            keydown: function ( event ) {
                switch ( event.code ) {
                    case keys.ok:
                        if ( filmList.$focusItem.data.value.censored || filmList.$focusItem.data.value.category.censored ) {
                            core.accessControl.request(function ( error ) {
                                if ( !error ) {
                                    app.route(app.pages.info, {info: filmList.$focusItem.data.value || {}});
                                }
                            });
                        } else {
                            app.route(app.pages.info, {info: filmList.$focusItem.data.value || {}});
                        }
                        break;
                }
            },
            focus: function () {
                Panel.prototype.defaultEvents.focus.call(this);
                footer.hide();
            }
        },
        children: [infoPanel.textArea, infoPanel.textArea.scroll]
    }),

    checkTime = 24 * 60 * 60,
    providerConfig = {
        size: 7,
        pages: 2
    },
    translations = [
        gettext('By name'),
        gettext('By rating'),
        gettext('By imdb rating'),
        gettext('By kinopoisk rating'),
        gettext('By date')
    ],
    inputConfig = {
        placeholder: gettext('Search'),
        value: ''
    },

    timers = {},
    actionItems,
    actionModal, modalPlayList, categoriesList, actionModalNotEnded,
    scrollbarList, genreList, modalScrollbar,
    selectGenre, selectCategories, sortFilm,
    listAction, listActionNotEnded;


/**
 * Add/remove focus item to/from favorite.
 *
 * @param {Object} video - movie data
 * @param {Function} callback - result handler
 */
function changeFavorite ( video, callback ) {
    var activeItem = filmList.$focusItem,
        // video = filmList.$focusItem.data.value,
        $icon = activeItem.layout.links.$favorite;

    if ( video === activeItem.data.value ) {
        if ( video.favorite ) {
            $icon.classList.add('hidden');
            activeItem.data.items[2].className = 'theme-icon theme-icon-favorite-active active hidden';
        } else {
            $icon.classList.remove('hidden');
            activeItem.data.items[2].className = 'theme-icon theme-icon-favorite-active active';
        }
    }

    video.changeFlags(
        {
            favorite: !video.favorite
        },
        /**
         * Favorite add/remove callback.
         *
         * @param {boolean} [error] - error flag
         * @param {boolean} [data] - done flag
         */
        function ( error, data ) {
            if ( error && video === activeItem.data.value ) {
                if ( video.favorite ) {
                    $icon.classList.remove('hidden');
                    activeItem.data.items[2].className = 'theme-icon theme-icon-favorite-active active';
                } else {
                    $icon.classList.add('hidden');
                    activeItem.data.items[2].className = 'theme-icon theme-icon-favorite-active active hidden';
                }
            }
            if ( callback ) {
                callback(error, data);
            }
        }
    );
}


/**
 * Prepare to play and play focus item.
 *
 * @param {number} continueWatch - continue watch
 */
function prepareToPlay ( continueWatch ) {
    var video = filmList.$focusItem.value,
        index = 0,
        name = video.name,
        series = [],
        seasons = [],
        indexes = {
            series: 0,
            seasons: 0
        },
        previousHandler, nextHandler,
        playerContext, intent,
        subtitles, file, checkFile;

    // Play focus item.
    function play ( error, url ) {

        function startPlay ( position ) {
            intent = core.intent({
                action: 'play',
                mime: 'content/video',
                data: {
                    title: name,
                    uri: url,
                    movie: video,
                    file: file,
                    position: position,
                    subtitles: subtitles,
                    mediaId: file.id
                },
                events: {
                    hide: function () {
                        page.saveVideo(null, {intent: intent, playerContext: playerContext}, true);
                        playerContext = null;
                        intent.close();
                    },
                    end: function () {
                        page.saveVideo(null, {intent: intent, playerContext: playerContext}, true);
                        if ( nextHandler ) {
                            nextHandler();

                            return;
                        }
                        playerContext = null;
                        intent.close();
                    },
                    error: function () {
                        playerContext = null;
                        intent.close();
                    },
                    stop: function () {
                        playerContext = null;
                        intent.close();
                    },
                    next: nextHandler,
                    prev: previousHandler,
                    close: function () {
                        page.saveVideo(null, {intent: intent, playerContext: playerContext});
                    }
                },
                context: playerContext
            }, function ( error, context ) {
                debug.fail('Playing error', error);
                playerContext = context;
            });
        }

        if ( error ) {
            return;
        }
        nextHandler = null;
        previousHandler = null;
        if ( video['is_tv_series'] ) {
            if ( indexes.series + 1 < series.length ) {
                nextHandler = function () {
                    var season = seasons[indexes.seasons];

                    index = ++indexes.series;

                    season.name = season.name
                        ? season.name + (season.original_name ? ' ( ' + season.original_name + ' )' : '')
                        : gettext('Season') + ' ' + season.number;

                    name = video.name + ' ' + season.name + ' ' +
                        (series[index].name ? series[index].name +
                            (series[index].original_name ?
                                ' ( ' + series[index].original_name + ' )' : '') : gettext('Series') + ' ' + series[index].number);

                    if ( series[index].files && series[index].files.length ) {
                        checkFile(series[index].files);
                    } else {
                        video.getEpisode({seasonId: season.id, episodeId: series[index].id}, function ( error, data ) {
                            if ( !error ) {
                                checkFile(data.files);
                            }
                        });
                    }
                };
            }

            if ( indexes.series > 0 ) {
                previousHandler = function () {
                    var season = seasons[indexes.seasons];

                    index = --indexes.series;

                    season.name = season.name
                        ? season.name + (season.original_name ? ' ( ' + season.original_name + ' )' : '')
                        : gettext('Season') + ' ' + season.number;

                    name = video.name + ' ' + season.name + ' ' +
                        (series[index].name
                            ? series[index].name + (series[index]['original_name'] ? ' ( ' + series[index]['original_name'] + ' )' : '')
                            : gettext('Series') + ' ' + series[index].number);

                    if ( series[index].files && series[index].files.length ) {
                        checkFile(series[index].files);
                    } else {
                        video.getEpisode({seasonId: season.id, episodeId: series[index].id}, function ( error, data ) {
                            if ( !error ) {
                                checkFile(data.files);
                            }
                        });
                    }
                };
            }
        }

        startPlay(continueWatch || 0);
    }

    checkFile = function ( data ) {
        var files = sortQuality(video, data);

        subtitles = files.subtitles;
        files = files.video;

        if ( !files.length ) {
            return;
        }

        if ( playerContext && !continueWatch ) {
            file = selectFile(files, playerContext.metadata.audioLang, intent.data.file);
            if ( file ) {
                file = file.value;
            } else {
                playerContext = null;
                intent.close();

                return;
            }
        } else {
            file = files[0];
            if ( video['last_watched_file_id'] && continueWatch ) {
                for ( index = 0; index < files.length; index++ ) {
                    if ( files[index].id === video['last_watched_file_id'] ) {
                        file = files[index];
                        break;
                    }
                }
            }
        }
        if ( file.url ) {
            play(false, file.url);
        } else {
            video.getUrl(file.id, play);
        }
    };

    if ( video['is_tv_series'] ) {
        video.getSeasons(function ( error, data ) {
            var season;

            if ( !error && data.length ) {
                season = data[0];
                seasons = data;
                if ( video['last_watched_season_id'] && continueWatch ) {
                    for ( index = 0; index < data.length; index++ ) {
                        if ( data[index].id === video['last_watched_season_id'] ) {
                            season = data[index];
                            indexes.seasons = index;
                            break;
                        }
                    }
                } else {
                    indexes.seasons = 0;
                }
                video.getSeries(season.id, function ( error, seriesData ) {
                    if ( !error && seriesData.length ) {
                        series = seriesData;
                        if ( video['last_watched_episode_id'] && continueWatch ) {
                            for ( index = 0; index < seriesData.length; index++ ) {
                                if ( seriesData[index].id === video['last_watched_episode_id'] ) {
                                    indexes.series = index;
                                    break;
                                }
                            }
                        } else {
                            indexes.series = 0;
                        }

                        season.name = season.name
                            ? season.name + (season.original_name ? ' ( ' + season.original_name + ' )' : '')
                            : gettext('Season') + ' ' + season.number;

                        name = video.name + ' ' + season.name + ' ' +
                            (series[index].name
                                ? series[index].name + (series[index].original_name ? ' ( ' + series[index].original_name + ' )' : '')
                                : gettext('Series') + ' ' + series[index].number);

                        if ( series[index].files && series[index].files.length ) {
                            checkFile(series[index].files);
                        } else {
                            video.getEpisode({seasonId: season.id, episodeId: series[index].id}, function ( error, list ) {
                                if ( !error ) {
                                    checkFile(list.files);
                                }
                            });
                        }

                    }
                });
            }

        });
    } else {
        checkFile(video.files);
    }
}


/**
 * Getter for video list.
 *
 * @param {Function} callback - result handler
 * @param {Object} config - request config
 */
function filmGetter ( callback, config ) {
    infoPanel.clear();

    app.api.getList(config, function ( error, data, count ) {
        $headerAmount.innerHTML = error ? 0 : count;
        callback(error, prepareMovies(data), count);
    });
}


/**
 * Reset data and init video list with saved filters.
 */
function refreshList () {
    filmList.setData({data: []});
    app.api.config.offset = filmList.provider.head;
    app.api.config.imit = filmList.provider.tail - filmList.provider.head;
    filmList.init({
        provider: new Provider({
            pageSize: providerConfig.size,
            cacheSize: providerConfig.pages,
            checkTime: checkTime,
            pos: filmList.provider.pos,
            request: app.api.config,
            getter: filmGetter,
            cycle: true,
            headItem: filmList.provider.headItem
        }),
        focusIndex: filmList.$focusItem ? filmList.$focusItem.index : 0
    });
}


function setWatched ( add ) {
    var video = filmList.$focusItem.data.value,
        activeItem = filmList.$focusItem;

    video.changeFlags({'watched_status': add ? 'watched' : 'not_watched'}, function ( error, data ) {
        var status;

        if ( !error && data ) {
            video['watched_status'] = status = add ? 'watched' : 'not_watched';
            activeItem.data.items[3].className = add ? 'theme-icon theme-icon-ok' : 'theme-icon theme-icon-ok hidden';
            activeItem.layout.links.$status.className = activeItem.data.items[3].className;

            if ( !video['is_tv_series'] ) {
                video.files.forEach(function ( item ) {
                    item['watched_status'] = status;
                });
            }
        }
    });
}


function showActionModal () {
    var data = filmList.$focusItem.data.value;

    if ( data['watched_status'] === 'not_ended' ) {
        actionModalNotEnded.show(data);
        actionModalNotEnded.focus();
    } else {
        actionModal.show();
        actionModal.focus();
    }
}


/**
 * Init page.
 */
function init () {
    var onFocusItem,
        leftListData = [
            {
                name: 'search',
                items: [
                    {
                        name: '$icon',
                        className: 'theme-icon theme-icon-search'
                    },
                    {
                        name: '$text',
                        value: gettext('Search'),
                        className: 'inputSearchField'
                    }
                ],
                click: function ( $item ) {
                    core.intent({
                        action: 'keyboard',
                        data: {
                            value: inputConfig.value,
                            title: gettext('VIDEO SEARCH')
                        },
                        events: {
                            done: function ( data ) {
                                inputConfig.value = data.value;
                                if ( data.value ) {
                                    $item.layout.links.$text.innerText = data.value;
                                    $item.layout.links.$icon.classList.add('active');
                                } else {
                                    $item.layout.links.$text.innerText = inputConfig.placeholder;
                                    $item.layout.links.$icon.classList.remove('active');
                                }
                                if ( app.api.config.search !== data.value ) {
                                    app.api.config.search = data.value;
                                    app.api.config.offset = 0;
                                    app.api.config.limit = 0;
                                    filmList.init({
                                        provider: new Provider({
                                            pageSize: providerConfig.size,
                                            cacheSize: providerConfig.pages,
                                            request: app.api.config,
                                            getter: filmGetter,
                                            checkTime: 0,
                                            cycle: true
                                        }),
                                        focusIndex: 0
                                    });
                                }

                            }
                        }
                    }, function ( error ) {
                        debug.fail('Keyboard error', error);
                    });
                }
            },
            {
                name: 'favorite',
                items: [
                    {
                        name: '$icon',
                        className: 'theme-icon theme-icon-favorite'
                    },
                    {
                        value: gettext('Favorite')
                    }
                ],
                click: function ( $item ) {
                    if ( app.api.config.favorite ) {
                        $item.layout.links.$icon.className = 'theme-icon theme-icon-favorite';
                    } else {
                        $item.layout.links.$icon.className = 'theme-icon theme-icon-favorite-active active';
                    }
                    filmList.setData({data: []});
                    app.api.config.favorite = !app.api.config.favorite;
                    app.api.config.offset = 0;
                    app.api.config.limit = 0;
                    filmList.init({
                        provider: new Provider({
                            pageSize: providerConfig.size,
                            cacheSize: providerConfig.pages,
                            request: app.api.config,
                            getter: filmGetter,
                            checkTime: checkTime,
                            cycle: true
                        }),
                        focusIndex: 0
                    });
                }
            },
            {
                name: 'genres',
                items: [
                    {
                        name: '$icon',
                        className: 'theme-icon theme-icon-genres'
                    },
                    {
                        name: '$text',
                        value: gettext('All genres'),
                        className: 'theme-item-more'
                    }
                ],
                click: function () {
                    panelSet.blur();
                    selectGenre.show();
                    selectGenre.focus();
                }
            },
            {
                name: 'categories',
                items: [
                    {
                        name: '$icon',
                        className: 'theme-icon theme-icon-categories'
                    },
                    {
                        name: '$text',
                        value: gettext('All categories'),
                        className: 'theme-item-more'
                    }
                ],
                click: function () {
                    panelSet.blur();
                    selectCategories.show();
                    selectCategories.focus();
                }
            },
            {
                name: 'sort',
                items: [
                    {
                        name: '$icon',
                        className: 'theme-icon theme-icon-sort-az'
                    },
                    {
                        name: '$text',
                        value: translations[app.api.config.sortby] || gettext('By date'),
                        className: 'theme-item-more'
                    }
                ],
                click: function () {
                    panelSet.blur();
                    sortFilm.show();
                    sortFilm.focus();
                }
            }
        ];

    app.api.config.offset = 0;
    app.api.config.limit = 0;

    if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
        leftListData.push({
            items: [
                {
                    className: 'theme-icon theme-icon-reset-filters'
                },
                {
                    value: gettext('Reset filters')
                }
            ],
            click: resetFilters
        });
    }

    leftListData.push({
        items: [
            {
                className: 'theme-icon theme-icon-exit'
            },
            {
                value: gettext('Exit')
            }
        ],
        click: exit.goExit
    });

    leftList.setData({
        focusIndex: leftList.$focusItem ? leftList.$focusItem.index : 0,
        data: leftListData
    });

    filmList = new LayoutList({
        provider: new Provider({
            pageSize: providerConfig.size,
            cacheSize: providerConfig.pages,
            request: app.api.config,
            getter: filmGetter,
            checkTime: checkTime,
            cycle: true
        }),
        events: {
            focus: function () {
                footer.init({
                    left: {
                        code: keys.menu,
                        action: function () {
                            if ( panelSet.panels[panelSet.focusIndex] === filmPanel ) {
                                panelSet.blur();
                                footer.hide();
                                showActionModal();
                            }
                        }
                    },
                    middle: [
                        {
                            code: keys.f3,
                            title: gettext('Favorite'),
                            action: function () {
                                if ( panelSet.panels[panelSet.focusIndex] === filmPanel ) {
                                    changeFavorite(filmList.$focusItem.data.value);
                                }
                            }
                        }
                    ],
                    label: {
                        code: keys.menu,
                        title: gettext('Hold OK button to open Options menu'),
                        action: function () {
                            if ( panelSet.panels[panelSet.focusIndex] === filmPanel ) {
                                panelSet.blur();
                                footer.hide();
                                showActionModal();
                            }
                        }
                    }
                });
                footer.show();
            },
            'focus:item': onFocusItem = function ( event ) {
                if ( timers.info ) {
                    clearTimeout(timers.info);
                }

                timers.info = setTimeout(function () {
                    var $curr = event.$curr;

                    if ( $curr ) {
                        if (
                            $curr.data.value
                            && ($curr.data.value.censored || ($curr.data.value.category && $curr.data.value.category.censored))
                            && !core.accessControl.state
                        ) {
                            infoPanel.showLock();
                        } else {
                            infoPanel.showInfo();
                            infoPanel.fill($curr.data.value);
                        }
                    }
                }, core.environment.onFocusDebounceTimeout);
            },
            'move:view': onFocusItem,
            'click:item': function ( event ) {
                if (
                    event.$item.data.value
                    && (event.$item.data.value.censored
                    || (event.$item.data.value.category && event.$item.data.value.category.censored))
                ) {
                    core.accessControl.request(function ( error ) {
                        if ( !error ) {
                            app.route(app.pages.info, {info: event.$item.data.value});
                        }
                    });
                } else {
                    app.route(app.pages.info, {info: event.$item.data.value || {}});
                }


            },
            'data:error': function ( error ) {
                console.log(error);
            }
        },
        size: providerConfig.size,
        render: require('../utils/list.item.render'),
        fixedData: true,
        className: 'videoList padded',
        noData: gettext('No films'),
        focusIndex: 0,
        scroll: scrollbarList = new Scrollbar({})
    });

    filmList.once('data:error', function () {
        filmList.focus();
        app.ready();
    });

    filmList.once('data:get', function () {
        filmList.focus();
        app.api.getCategories(function ( error, data ) {
            var result = [],
                index;

            debug.fail('Request error', error);
            data = data.data || [];
            result.push({
                state: true,
                title: gettext('All categories'),
                value: ''
            });

            for ( index = 0; index < data.length; index++ ) {
                result.push({
                    state: false,
                    title: data[index].name,
                    value: data[index].id
                });
            }
            categoriesList.setData({data: result, focusIndex: 0});

            app.api.getGenres(function ( error, genres ) {
                result = [];

                debug.fail('Request error', error);
                genres = genres.data || [];
                result.push({
                    state: true,
                    title: gettext('All genres'),
                    value: ''
                });

                for ( index = 0; index < genres.length; index++ ) {
                    result.push({
                        state: false,
                        title: genres[index].name,
                        value: genres[index].ids.join(',')
                    });
                }
                genreList.setData({data: result, focusIndex: 0});
            });
        });
        app.ready();
    });
    filmPanel.add(filmList);
    filmPanel.add(scrollbarList);
    filmPanel.focus();

    if ( DEVELOP ) {
        window.leftList = leftList;
        window.listAction = listAction;
        window.filmList = filmList;
        window.modalPlayList = modalPlayList;
    }
}


/**
 * Reset all filters.
 */
resetFilters = function () {
    if (
        app.api.config.genreId !== ''
        || app.api.config.categoryId !== ''
        || app.api.config.search !== ''
        || app.api.config.favorite
    ) {
        app.api.config = {
            sortby: app.api.config.sortby,
            genreId: '',
            categoryId: '',
            favorite: false,
            search: '',
            limit: 0,
            offset: 0
        };


        filmList.setData({data: []});
        filmList.init({
            provider: new Provider({
                pageSize: providerConfig.size,
                cacheSize: providerConfig.pages,
                request: app.api.config,
                getter: filmGetter,
                checkTime: checkTime,
                cycle: true
            }),
            focusIndex: 0
        });

        if ( genreList.$checkedData ) {
            genreList.$checkedData.state = false;
            genreList.data[0].state = true;
        }
        genreList.setData({data: genreList.data, focusIndex: 0});
        if ( categoriesList.$checkedData ) {
            categoriesList.$checkedData.state = false;
            categoriesList.data[0].state = true;
        }

        leftList.links.categories.links.$text.innerText = gettext('All categories');
        leftList.links.categories.links.$icon.classList.remove('active');

        leftList.links.genres.links.$text.innerText = gettext('All genres');
        leftList.links.genres.links.$icon.classList.remove('active');

        inputConfig.value = '';
        leftList.links.search.links.$text.innerText = inputConfig.placeholder;
        leftList.links.search.links.$icon.classList.remove('active');

        leftList.links.favorite.links.$icon.className = 'theme-icon theme-icon-favorite';

        categoriesList.setData({data: categoriesList.data, focusIndex: 0});
    }
};


panelSet = new PanelSet({
    visible: false,
    panels: [leftPanel, filmPanel, rightPanel]
});
page.add(panelSet);


actionItems = {
    play: {
        items: [
            {
                className: 'theme-icon theme-icon-play'
            },
            {
                className: 'title',
                value: gettext('Play')
            }
        ],
        click: function () {
            actionModal.hide();
            if ( filmList.$focusItem.data.value.censored || filmList.$focusItem.data.value.category.censored ) {
                core.accessControl.request(function ( error ) {
                    if ( !error ) {
                        prepareToPlay();
                    }
                });
            } else {
                prepareToPlay();
            }
        }
    },
    favorite: {
        name: 'favorite',
        items: [
            {
                name: '$icon',
                className: 'theme-icon theme-icon-favorite'
            },
            {
                name: '$title',
                className: 'title',
                value: gettext('Add to favorite')
            }
        ],
        click: function () {
            actionModal.hide();
            actionModalNotEnded.hide();
            changeFavorite(filmList.$focusItem.data.value);
        }
    },
    watched: {
        name: 'watchedStatus',
        items: [
            {
                name: '$icon',
                className: 'theme-icon theme-icon-ok'
            },
            {
                name: '$title',
                className: 'title',
                value: gettext('Mark as watched')
            }
        ],
        click: function () {
            actionModal.hide();
            actionModalNotEnded.hide();
            setWatched(filmList.$focusItem.data.value['watched_status'] !== 'watched');
        }
    },
    continueWatch: {
        name: 'continueWatch',
        items: [
            {
                className: 'theme-icon'
            },
            {
                name: '$title',
                className: 'title',
                value: gettext('Continue watching from')
            }
        ],
        click: function () {
            actionModalNotEnded.hide();
            if ( actionModalNotEnded.videoData.censored
                || (actionModalNotEnded.videoData.category && actionModalNotEnded.videoData.category.censored) ) {
                core.accessControl.request(function ( error ) {
                    if ( !error ) {
                        prepareToPlay(actionModalNotEnded.videoData['watched_time'] || 0);
                    }
                });
            } else {
                prepareToPlay(actionModalNotEnded.videoData['watched_time'] || 0);
            }

        }
    },
    watchAgain: {
        items: [
            {
                className: 'theme-icon'
            },
            {
                name: '$title',
                className: 'title',
                value: gettext('Watch again')
            }
        ],
        click: function () {
            actionModalNotEnded.hide();
            if ( filmList.$focusItem.data.value.censored || filmList.$focusItem.data.value.category.censored ) {
                core.accessControl.request(function ( error ) {
                    if ( !error ) {
                        prepareToPlay();
                    }
                });
            } else {
                prepareToPlay();
            }
        }
    }
};

// action menu center
actionModal = new ModalMessage({
    title: gettext('Actions'),
    className: 'width2x',
    events: {
        show: function () {
            var data = filmList.$focusItem.data.value,
                linksFavorite = listAction.links.favorite.links,
                linksWatchedStatus = listAction.links.watchedStatus.links;

            if ( data.favorite ) {
                linksFavorite.$icon.className = 'theme-icon theme-icon-favorite-active active';
                linksFavorite.$title.innerText = gettext('Remove from favorites');
            } else {
                linksFavorite.$icon.className = 'theme-icon theme-icon-favorite';
                linksFavorite.$title.innerText = gettext('Add to favorite');
            }

            if ( data['watched_status'] === 'watched' ) {
                linksWatchedStatus.$icon.className = 'theme-icon';
                linksWatchedStatus.$title.innerText = gettext('Remove from watched');
            } else {
                linksWatchedStatus.$icon.className = 'theme-icon theme-icon-ok';
                linksWatchedStatus.$title.innerText = gettext('Mark as watched');
            }
        },
        hide: function () {
            panelSet.focus();
        }
    },
    children: [
        listAction = new LayoutList({
            size: 3,
            focusIndex: 0,
            cycle: true,
            fixedData: true,
            data: [
                actionItems.play,
                actionItems.favorite,
                actionItems.watched
            ],
            events: {
                keydown: function ( event ) {
                    LayoutList.prototype.defaultEvents.keydown.call(this, event);
                    switch ( event.code ) {
                        case keys.menu:
                        case keys.back:
                            actionModal.hide();
                            event.stop = true;
                            break;
                    }
                }
            }
        })
    ]
});
page.add(actionModal);


// action menu center
actionModalNotEnded = new ModalMessage({
    title: gettext('Actions'),
    className: 'width2x',
    events: {
        show: function ( data ) {
            var linksFavorite = listActionNotEnded.links.favorite.links,
                linksWatchedStatus = listActionNotEnded.links.watchedStatus.links;

            this.videoData = data;
            this.children[0].focus();
            this.$text.innerText = data.name;
            listActionNotEnded.links.continueWatch.links.$title.innerText = gettext('Continue watching from') + ' ' +
                parseTime(data['watched_time'] || 0);

            if ( data.favorite ) {
                linksFavorite.$icon.className = 'theme-icon theme-icon-favorite-active active';
                linksFavorite.$title.innerText = gettext('Remove from favorites');
            } else {
                linksFavorite.$icon.className = 'theme-icon theme-icon-favorite';
                linksFavorite.$title.innerText = gettext('Add to favorite');
            }

            if ( data['watched_status'] === 'watched' ) {
                linksWatchedStatus.$icon.className = 'theme-icon';
                linksWatchedStatus.$title.innerText = gettext('Remove from watched');
            } else {
                linksWatchedStatus.$icon.className = 'theme-icon theme-icon-ok';
                linksWatchedStatus.$title.innerText = gettext('Mark as watched');
            }
        },
        hide: function () {
            panelSet.focus();
        }
    },
    children: [
        listActionNotEnded = new LayoutList({
            size: 4,
            focusIndex: 0,
            cycle: true,
            fixedData: true,
            data: [
                actionItems.continueWatch,
                actionItems.watchAgain,
                actionItems.favorite,
                actionItems.watched
            ],
            events: {
                keydown: function ( event ) {
                    LayoutList.prototype.defaultEvents.keydown.call(this, event);
                    switch ( event.code ) {
                        case keys.menu:
                        case keys.back:
                            actionModalNotEnded.hide();
                            event.stop = true;
                            break;
                    }
                }
            }
        })
    ]
});
page.add(actionModalNotEnded);


// sort list selection modal
sortFilm = new ModalMessage({
    visible: false,
    title: gettext('Sort'),
    events: {
        show: function () {
            this.children[0].focus();
        }
    },
    children: [
        new RadioList({
            focusIndex: 0,
            size: 3,
            cycle: true,
            data: [
                {
                    state: true,
                    title: gettext('By date'),
                    value: 'added'
                },
                {
                    state: false,
                    title: gettext('By name'),
                    value: 'name'
                },
                {
                    state: false,
                    title: gettext('By rating'),
                    value: 'rating'
                }
            ],
            events: {
                'click:item': function () {
                    sortFilm.hide();
                    panelSet.focus();
                },
                select: function ( data ) {
                    leftList.links.sort.links.$text.innerText = data.$curr.data.title;
                    filmList.setData({data: []});
                    app.api.config.sortby = data.$curr.data.value;
                    app.api.config.offset = 0;
                    app.api.config.limit = 0;
                    filmList.init({
                        provider: new Provider({
                            pageSize: providerConfig.size,
                            cacheSize: providerConfig.pages,
                            request: app.api.config,
                            getter: filmGetter,
                            checkTime: checkTime,
                            cycle: true
                        }),
                        focusIndex: 0
                    });
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    switch ( event.code ) {
                        case keys.back:
                            sortFilm.hide();
                            panelSet.focus();
                            event.stop = true;
                            break;
                    }
                }
            }
        })
    ]
});
page.add(sortFilm);


// categories list selection modal
selectCategories = new ModalMessage({
    visible: false,
    title: gettext('Categories'),
    events: {
        show: function () {
            this.children[0].focus();
        }
    },
    children: [
        categoriesList = new RadioList({
            focusIndex: 0,
            size: 5,
            cycle: true,
            scroll: modalScrollbar = new Scrollbar(),
            events: {
                'click:item': function () {
                    selectCategories.hide();
                    panelSet.focus();
                },
                select: function ( data ) {
                    leftList.links.categories.links.$text.innerText = data.$curr.data.title;
                    if ( data.$curr.data.value ) {
                        leftList.links.categories.links.$icon.classList.add('active');
                    } else {
                        leftList.links.categories.links.$icon.classList.remove('active');
                    }
                    filmList.setData({data: []});
                    app.api.config.categoryId = data.$curr.data.value;
                    app.api.config.offset = 0;
                    app.api.config.limit = 0;
                    filmList.init({
                        provider: new Provider({
                            pageSize: providerConfig.size,
                            cacheSize: providerConfig.pages,
                            request: app.api.config,
                            getter: filmGetter,
                            checkTime: checkTime,
                            cycle: true
                        }),
                        focusIndex: 0
                    });
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    switch ( event.code ) {
                        case keys.back:
                            selectCategories.hide();
                            panelSet.focus();
                            event.stop = true;
                            break;
                    }
                }
            }
        }),
        modalScrollbar
    ]
});
page.add(selectCategories);


selectGenre = new ModalMessage({
    visible: false,
    title: gettext('Genres'),
    events: {
        show: function () {
            this.children[0].focus();
        }
    },
    children: [
        genreList = new RadioList({
            focusIndex: 0,
            size: 5,
            cycle: true,
            scroll: modalScrollbar = new Scrollbar(),
            events: {
                'click:item': function () {
                    selectGenre.hide();
                    panelSet.focus();
                },
                select: function ( data ) {
                    leftList.links.genres.links.$text.innerText = data.$curr.data.title;
                    if ( data.$curr.data.value ) {
                        leftList.links.genres.links.$icon.classList.add('active');
                    } else {
                        leftList.links.genres.links.$icon.classList.remove('active');
                    }
                    filmList.setData({data: []});
                    app.api.config.genreId = data.$curr.data.value;
                    app.api.config.offset = 0;
                    app.api.config.limit = 0;
                    filmList.init({
                        provider: new Provider({
                            pageSize: providerConfig.size,
                            cacheSize: providerConfig.pages,
                            request: app.api.config,
                            getter: filmGetter,
                            checkTime: checkTime,
                            cycle: true
                        }),
                        focusIndex: 0
                    });
                },
                keydown: function ( event ) {
                    RadioList.prototype.defaultEvents.keydown.call(this, event);
                    switch ( event.code ) {
                        case keys.back:
                            selectGenre.hide();
                            panelSet.focus();
                            event.stop = true;
                            break;
                    }
                }
            }
        }),
        modalScrollbar
    ]
});
page.add(selectGenre);


// action menu left
if ( TARGET !== 'android-stb' && TARGET !== 'android-app' ) {
    actionModalReset = new ModalMessage({
        title: gettext('Actions'),
        className: 'width2x',
        events: {
            hide: function () {
                panelSet.focus();
            }
        },
        children: [
            new LayoutList({
                size: 1,
                focusIndex: 0,
                cycle: true,
                fixedData: true,
                data: [
                    {
                        items: [
                            {
                                className: 'theme-icon theme-icon-rc-f1'
                            },
                            {
                                value: gettext('Reset filters')
                            }
                        ],
                        click: function () {
                            actionModalReset.hide();
                            resetFilters();
                        }
                    }
                ],
                events: {
                    keydown: function ( event ) {
                        LayoutList.prototype.defaultEvents.keydown.call(this, event);
                        switch ( event.code ) {
                            case keys.menu:
                            case keys.back:
                                actionModalReset.hide();
                                event.stop = true;
                                break;
                        }
                    }
                }
            })
        ]
    });
    page.add(actionModalReset);
}


page.saveVideo = function ( callback, data, end ) {
    var activeItem = filmList.$focusItem.data,
        item, position, duration,
        progress, config;

    function add ( error, statusData ) {
        var index;

        if ( !error && statusData && statusData.status ) {
            item.file['watched_status'] = config['watched_status'];
            item.movie['watched_status'] = statusData['movie_watched_status'];
            switch ( item.movie['watched_status'] ) {
                case 'watched':
                    activeItem.items[3].className = 'theme-icon theme-icon-ok';
                    if ( item.episode ) {
                        item.episode.items[1].className = 'theme-icon theme-icon-ok';
                    }
                    break;

                case 'not_watched':
                    activeItem.items[3].className = 'theme-icon theme-icon-ok hidden';
                    if ( item.episode ) {
                        item.episode.items[1].className = 'theme-icon theme-icon-ok hidden';
                    }
                    break;

                case 'not_ended':
                    activeItem.items[3].className = 'theme-icon theme-icon-ok disabled';
                    if ( item.episode ) {
                        item.episode.items[1].className = 'theme-icon theme-icon-ok disabled';
                    }
                    break;
            }

            if ( statusData['season_watched_status'] && item.season ) {
                item.season.value['watched_status'] = statusData['season_watched_status'];
                switch ( item.season.value['watched_status'] ) {
                    case 'watched':
                        item.season.items[1].className = 'theme-icon theme-icon-ok';
                        break;

                    case 'not_watched':
                        item.season.items[1].className = 'theme-icon theme-icon-ok hidden';
                        break;

                    case 'not_ended':
                        item.season.items[1].className = 'theme-icon theme-icon-ok disabled';
                        break;
                }
            }

            if ( item.episode ) {
                for ( index = 0; index < item.episode.value.files.length; index++ ) {
                    if ( item.episode.value.files[index].id === item.file.id ) {
                        item.episode.value.files[index]['watched_status'] = config['watched_status'];
                        if ( config['watched_time'] ) {
                            item.episode.value.files[index]['watched_time'] = config['watched_time'];
                        }
                        item.episode.value['watched_status'] = config['watched_status'];
                        switch ( config['watched_status'] ) {
                            case 'watched':
                                item.episode.items[1].className = 'theme-icon theme-icon-ok';
                                break;

                            case 'not_watched':
                                item.episode.items[1].className = 'theme-icon theme-icon-ok hidden';
                                break;

                            case 'not_ended':
                                item.episode.items[1].className = 'theme-icon theme-icon-ok disabled';
                                break;
                        }
                        break;
                    }
                }
            }

            if ( config['watched_time'] ) {
                item.file['watched_time'] = config['watched_time'];
            }

            page.refreshList();
            if ( callback ) {
                callback();
            }
        }

    }

    if ( data.intent.data && data.playerContext ) {
        position = data.playerContext.metadata.position;
        duration = data.playerContext.metadata.duration;
        item = data.intent.data;
        if ( end ) {
            config = {
                'watched_status': 'watched',
                'watched_time': duration - 10
            };
            item.movie.changeWatchedFile(item.file.id, config, add);
        } else if ( position > 10 ) {
            if ( position && duration ) {
                progress = position / duration * 100;
                if ( progress > 95 ) {
                    config = {
                        'watched_status': 'watched',
                        'watched_time': position - 10
                    };
                } else if ( progress > 5 ) {
                    config = {
                        'watched_status': 'not_ended',
                        'watched_time': position - 10
                    };
                }
                item.movie.changeWatchedFile(item.file.id, config, add);
            }
        }

    }
};


page.refreshList = function ( check ) {
    var item;

    if ( check ) {
        item = filmList.$focusItem.data;
        switch ( item.value['watched_status'] ) {
            case 'watched':
                item.items[3].className = 'theme-icon theme-icon-ok';
                break;
            case 'not_watched':
                item.items[3].className = 'theme-icon theme-icon-ok hidden';
                break;
            case 'not_ended':
                item.items[3].className = 'theme-icon theme-icon-ok disabled';
                break;
        }
    }

    if ( filmList.data.length && filmList.$focusItem ) {
        filmList.setData({data: filmList.data, focusIndex: filmList.$focusItem.index});
    }
};


page.once('show', init);


// reset on show
page.addListeners({
    show: function () {
        panelSet.show();
        panelSet.focus();
        // app.api.playerContext = null;
    },

    keydown: function ( event ) {
        switch ( event.code ) {
            case keys.back:
                //case keys.exit:
                panelSet.blur();
                exit.goBack();
                // if ( app.events['exit'] ) {
                //     app.emit('exit');
                // }
                // core.call('exit');
                break;

            // case keys.playPause:
            //     if ( panelSet.panels[panelSet.focusIndex] === filmPanel ) {
            //         if ( filmList.$focusItem.data.value.censored || filmList.$focusItem.data.value.category.censored ) {
            //             core.accessControl.request(function ( error ) {
            //                 if ( !error ) {
            //                     prepareToPlay();
            //                 }
            //             });
            //         } else {
            //             prepareToPlay();
            //         }
            //     }
            //     break;
        }
    }
});


// favorite action from info page
app.addListener('change:favorite', function ( data ) {
    data = data || {};
    changeFavorite(data.video, data.callback);
});


core.addListeners({
    show: function ( event ) {
        switch ( event.source ) {
            case core.SOURCES.LAUNCHER:
                if ( app.api.config.search ) {
                    return;
                }

                refreshList();
                // app.api.playerContext = null;
                break;
        }
    },

    intent: function ( intent, callback ) {
        if ( intent.action === 'videoClub' ) {
            switch ( intent.mime ) {
                case 'info':
                    if ( intent.data ) {
                        if ( app.pages.info === app.activePage ) {
                            app.pages.info.emit('show', {
                                data: {
                                    info: intent.data,
                                    type: 'intent',
                                    callback: callback
                                }
                            });
                        } else {
                            app.route(app.pages.info, {
                                info: intent.data,
                                type: 'intent',
                                callback: callback
                            });
                        }
                        callback(false, null);
                    } else {
                        callback(true, null);
                    }

                    break;

                default:
                    app.route(app.pages.main);
                    callback(false, null);
                    break;
            }
        }
    }
});


module.exports = page;
